import * as types from '../actions/types';

const initialState = {
    searchvaluedata:{
        searchdata: "",
        type: "",
    },
    success: false
}

export default function tutorialSearchValueReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.TUTORIAL_LIST_SEARCH_INPUT:
            return {
                searchvaluedata:action.payload,
                success: true
            } 
        default:return state
    }
}